import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Select from "shared/components/Form/Select";
import PrimaryButton from "shared/components/PrimaryButton";
import {
  BORDER,
  COLOR_GREY_11,
  COLOR_GREY_5,
  COLOR_WHITE,
} from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledModal = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-paper {
      border-radius: 1rem;
    }
  }
`;

export const StyledBox = styled(Box)`
  ${flex({ fd: "column" })};
  min-width: 560px;
  padding: 1.5rem 1rem;
  row-gap: 1.5rem;
`;

export const StyledTitle = styled(Typography)`
  text-align: left;
  font-weight: 700;
`;

export const StyledButtonsPopup = styled(Box)`
  ${flex({ jc: "flex-end", ai: "center" })};
  column-gap: 1rem;
`;

export const StyledCancelButton = styled(PrimaryButton)`
  &.MuiButton-root {
    color: ${COLOR_GREY_11};
    font-weight: 700;
    font-size: 1rem;
    border: 1px solid #d4d4d4;

    &.rounded {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledSaveButton = styled(PrimaryButton)`
  &.MuiButton-root {
    color: ${COLOR_WHITE};
    font-weight: 700;
    font-size: 1rem;
    border-radius: 0.5rem;

    &.rounded {
      border-radius: 0.5rem;
    }
  }
`;

export const StyledSelect = styled(Select)`
  &.MuiInput-root .MuiNativeSelect-select {
    padding: 0 2rem 0 1rem;
    border-radius: 0.5rem;
    height: 40px;
    background-color: ${COLOR_WHITE};
    border: ${BORDER(1, COLOR_GREY_5)};
  }
`;
